import styled, { keyframes } from 'styled-components';
import { focusOutline } from 'themes/helpers';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideIn = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.space(4)}px;
  overflow-y: auto;

  @media (prefers-reduced-motion: no-preference) {
    animation: ${fadeIn} 0.2s ease-out;
  }
`;

export const ModalContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.neutral.surface};
  border-radius: 8px;
  max-width: 704px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  padding: ${({ theme }) => theme.space(4)}px;
  z-index: 1001;
  margin: auto;

  @media (prefers-reduced-motion: no-preference) {
    animation: ${slideIn} 0.3s ease-out;
  }

  @media (min-width: 768px) {
    padding: ${({ theme }) => theme.space(6)}px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.space(4)}px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize[3]}px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.neutral.text};
  flex: 1;
  padding-inline-end: ${({ theme }) => theme.space(4)}px;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: ${({ theme }) => theme.space(2)}px;
  margin: -${({ theme }) => theme.space(2)}px;
  margin-inline-end: -${({ theme }) => theme.space(2)}px;
  color: ${({ theme }) => theme.palette.neutral.text};
  font-size: 24px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.palette.neutral.neutral30};
  }

  ${focusOutline({})};
`;

export const ModalContent = styled.div`
  color: ${({ theme }) => theme.palette.neutral.text};
`;
